import React, { useState } from "react";
import { Link } from "react-router-dom";
import emailjs from "emailjs-com";

// Images
import bnrImg from "../../images/banner/bnr1.jpg";
import {
  address,
  email,
  facebookUrl,
  instagramUrl,
  tiktokUrl,
  telefon,
} from "../../utils/constants";
import { Helmet } from "react-helmet-async";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    phone: "",
  });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, email, message, phone } = formData;

    emailjs
      .send(
        "service_bpsqf9h",
        "template_73razhr",
        {
          from_name: name,
          from_email: email,
          message: message,
          phone: phone,
        },
        "Qx2zfaTMDcEJ0Rern"
      )
      .then((response) => {
        // Show the success message and clear the form
        setStatus({ message: "Meddelandet skickades!", success: true });

        setFormData({
          name: "",
          email: "",
          message: "",
          phone: "",
        });

        // Reset the status after 5 seconds
        setTimeout(() => {
          setStatus(null);
        }, 5000);
      })
      .catch((error) => {
        // Show the error message but keep the form data
        setStatus({
          message: "Fel vid skickande av meddelande.",
          success: false,
        });

        // Reset the status after 5 seconds
        setTimeout(() => {
          setStatus(null);
        }, 5000);
      });
  };

  return (
    <>
      <Helmet>
        <title>Kontakta Oss- KBS Center i Göteborg</title>
      </Helmet>
      <div className="page-content bg-white">
        <div
          className="page-banner ovbl-dark"
          style={{ backgroundImage: `url(${bnrImg})` }}
        >
          <div className="container">
            <div className="page-banner-entry text-center">
              <h2 className="banner">
                <span>Kontakta Oss</span>
              </h2>
              <nav aria-label="breadcrumb" className="breadcrumb-row">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">
                      <i className="las la-home"></i>Hem
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Kontakta Oss
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>

        <section className="section-area section-sp1">
          <div className="container">
            <div className="heading-bx mb-20">
              <h6 className="title-ext text-primary">Kontakt Info</h6>
              <h4 className="title mb-0">KONTAKTA OSS</h4>
              <p className="mb-5">
                Har du frågor om våra tjänster, eller vill du boka en tid? Vårt
                team på KBS Center finns här för att hjälpa dig med alla dina
                bilvårdsbehov. Vi är stolta över att kunna erbjuda våra kunder
                snabb och pålitlig service. Besök oss på vår verkstad eller
                kontakta oss via telefon eller e-post. Vi ser fram emot att
                hjälpa dig!
              </p>
              <h4 className="title mb-0">
                VAR VI FINNS OCH HUR <br />
                DU NÅR OSS
              </h4>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="icon-box">
                  <h6 className="title">
                    <i className="ti-map-alt"></i>Plats
                  </h6>
                  {address}
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="icon-box">
                  <h6 className="title">
                    <i className="ti-id-badge"></i>E-post & Telefon
                  </h6>
                  <Link to={`mailto:${email}`}>{email}</Link>
                  <p>
                    <Link href={`tel:${telefon}`}>{telefon}</Link>
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="icon-box">
                  <h6 className="title">
                    <i className="ti-world"></i>Följ oss
                  </h6>
                  <ul className="social-media">
                    <li>
                      <a
                        target="_blank"
                        href={instagramUrl}
                        rel="noreferrer"
                        className="btn btn-primary"
                      >
                        <i className="fa-brands fa-instagram"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href={tiktokUrl}
                        rel="noreferrer"
                        className="btn btn-primary"
                      >
                        <i className="fa-brands fa-tiktok"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href={facebookUrl}
                        rel="noreferrer"
                        className="btn btn-primary"
                      >
                        <i className="fa-brands fa-facebook"></i>
                      </a>
                    </li>
                    {/* <li>
                      <a target="_blank" href="https://youtube.com/" rel="noreferrer" className="btn btn-primary">
                        <i className="fa-brands fa-youtube"></i>
                      </a>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div
          className="section-area container"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "450px",
          }}
        >
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2121.2373433195135!2d11.982156677420113!3d57.882138273946076!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x464560bb3ab1aef9%3A0x119508079283343f!2sFilaregatan%206%2C%20442%2034%20Kung%C3%A4lv!5e0!3m2!1ssv!2sse!4v1731741923103!5m2!1ssv!2sse"
            loading="lazy"
            className="d-flex"
            style={{ width: "100%", height: "100%" }}
            title="map"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        <section className="section-area section-sp2">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12">
                <form
                  onSubmit={handleSubmit}
                  className="contact-form ajax-form"
                >
                  <div className="heading-bx mb-20">
                    <h6 className="title-ext text-primary">Kontaktformulär</h6>
                    <h4 className="title mb-0">
                      BOKA EN TID ELLER FRÅGA
                      <br /> OSS NÅGOT
                    </h4>
                  </div>
                  <div className="row">
                    <div className="col-lg-4 col-md-6">
                      <div className="form-group">
                        <div className="input-group">
                          <input
                            name="name"
                            type="text"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            className="form-control valid-character"
                            placeholder="Ditt Namn"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="form-group">
                        <div className="input-group">
                          <input
                            name="email"
                            type="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            className="form-control"
                            placeholder="Din E-postadress"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-12">
                      <div className="form-group">
                        <div className="input-group">
                          <input
                            name="phone"
                            type="text"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                            className="form-control int-value"
                            placeholder="Ditt Telefonnummer"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group">
                        <div className="input-group">
                          <textarea
                            name="message"
                            rows="4"
                            value={formData.message}
                            onChange={handleChange}
                            required
                            className="form-control"
                            placeholder="Skriv ditt Meddelande här"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group">
                        <button type="submit" className="btn btn-primary">
                          Skicka Meddelande
                        </button>
                      </div>
                    </div>
                  </div>
                  {status && (
                    <p
                      style={{
                        color: status.success ? "green" : "red",
                      }}
                    >
                      {status.message}
                    </p>
                  )}
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ContactUs;
